module.exports = require("./vi.d.ts");